import styled from 'styled-components';
import Map from '../core/Map.js';

const FullscreenMap = styled(Map)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

export default FullscreenMap;
